<template>
  <v-select
    v-model="modelValue"
    :items="items"
    class="mt-4"
    :label="$attrs.readonly ? '' : label ?? 'Select'"
    return-object
    color="primary"
    @click.stop
    hide-details
    item-title="year"
    filled
    item-text="id"
    :menu-icon="$attrs.readonly ? '' : undefined"
  >
  </v-select>
</template>
<script setup>
defineProps({
  items: { type: Array, required: true },
  label: { type: String, default: '' }
})

const modelValue = defineModel({
  type: Object,
  required: true,
  default: null
})
</script>
